export enum DateFormat {
  USShort = 'USShort',         // 1/31/2026
  ISODate = 'ISODate',         // 2026-01-31
  USLong = 'USLong',           // January 31, 2026
}

export class DateUtilities {

  public static format(date: Date, format: DateFormat = DateFormat.USShort): string {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    switch (format) {
      case DateFormat.USShort:
        return `${month}/${day}/${year}`;

      case DateFormat.ISODate:
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

      case DateFormat.USLong:
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }
  }

  public static parseLocalDate(isoDateStr: string): Date {
    const datePart = isoDateStr.split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  public static todayISO(): string {
    return DateUtilities.format(new Date(), DateFormat.ISODate);
  }

  public static startOfToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  public static isPastDate(isoDateStr: string | null | undefined): boolean {
    if (!isoDateStr) return false;
    return DateUtilities.parseLocalDate(isoDateStr) < DateUtilities.startOfToday();
  }

  public static addDays(date: Date, days: number): Date {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    result.setDate(result.getDate() + days);
    return result;
  }

  public static lastDayOfMonth(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

}
